module.exports = __webpack_public_path__ + "img/19.a004baf9.png";